/* DON'T EDIT THIS FILE: edit original and run build again */ import { matchfinTenant } from "../../framework/tenant-matchfin-code/matchfin-tenant-code.ts";

export const tenantHasSgrsReportsSection = (tenant: string) =>
  tenant === matchfinTenant;
